export const commonFields = [
  { name: 'isActive', displayName: 'Active' },
  { name: 'firstDate', displayName: 'First Date' },
  { name: 'lastDate', displayName: 'Last Date' },
  { name: 'firstUser', displayName: 'First User' },
  { name: 'lastUser', displayName: 'Last User' },
];
